import Client from "..";
import { BootScene } from "../scenes/BootScene";
import { GameScene } from "../scenes/GameScene";
import { LoadLevelScene } from "../scenes/LoadLevelScene";
import { MainMenuScene } from "../scenes/MainMenuScene";

export class Global {
  public static gameVersion: string = "0.0.1"; // Default value
  public static debug: boolean = false; // Set to false for production
  public static renderScale: number = 1;
  public static gameConfig: Phaser.Types.Core.GameConfig = {
    scale: {
      mode: Phaser.Scale.ScaleModes.EXPAND,
      width: window.innerWidth * this.renderScale,
      height: window.innerHeight * this.renderScale,
      parent: "game",
    },
    physics: {
      default: "arcade",
      arcade: {
        gravity: { x: 0, y: 0 }, // No gravity for wheel rotation
        debug: Global.debug,
      },
    },
    render: {
      powerPreference: "high-performance",
      antialias: false,
      antialiasGL: false,
      roundPixels: true,
      pixelArt: true,
    },
    type: Phaser.WEBGL,
    scene: [BootScene, MainMenuScene, LoadLevelScene, GameScene],
    disableContextMenu: true,
    banner: false,
    backgroundColor: "#604c7d",
  };

  public static enableShaders: boolean = true;
  public static enableCameraBobbing: boolean = true;

  public static get minFontSize(): number {
    return Math.round(
      Math.min(Client.game!.scale.width, Client.game!.scale.height) * 0.02,
    );
  }

  // Detect if we're running in Tauri
  private static get isTauri(): boolean {
    return typeof window !== "undefined" && "__TAURI__" in window;
  }

  // Base URLs that work in both web and Tauri environments
  private static get baseAssetPath(): string {
    // In Tauri, assets are served from the asset protocol
    // In web, they're served from relative paths
    return this.isTauri ? "asset://localhost/" : "./";
  }

  public static get graphicsBaseUrl(): string {
    return `${this.baseAssetPath}assets/graphics/`;
  }

  public static get audioBaseUrl(): string {
    return `${this.baseAssetPath}assets/audio/`;
  }

  public static get fontBaseUrl(): string {
    return `${this.baseAssetPath}assets/fonts/`;
  }

  public static get shaderBaseUrl(): string {
    return `${this.baseAssetPath}assets/shaders/`;
  }

  /**
   * Get the full path for a graphics asset
   */
  public static getGraphicsPath(filename: string): string {
    return `${this.graphicsBaseUrl}${filename}`;
  }

  /**
   * Get the full path for an audio asset
   */
  public static getAudioPath(filename: string): string {
    return `${this.audioBaseUrl}${filename}`;
  }

  /**
   * Get the full path for a font asset
   */
  public static getFontPath(filename: string): string {
    return `${this.fontBaseUrl}${filename}`;
  }

  /**
   * Get the full path for a shader asset
   */
  public static getShaderPath(filename: string): string {
    return `${this.shaderBaseUrl}${filename}`;
  }

  /**
   * Get the full path for any asset
   */
  public static getAssetPath(relativePath: string): string {
    return `${this.baseAssetPath}${relativePath}`;
  }

  /**
   * Log asset loading information for debugging
   */
  public static logAssetInfo(): void {
    console.log("Asset loading info:", {
      isTauri: this.isTauri,
      baseAssetPath: this.baseAssetPath,
      graphicsBaseUrl: this.graphicsBaseUrl,
      audioBaseUrl: this.audioBaseUrl,
      fontBaseUrl: this.fontBaseUrl,
    });
  }
}
